import { render, staticRenderFns } from "./valueSwitch.vue?vue&type=template&id=3b893610&scoped=true"
import script from "./valueSwitch.vue?vue&type=script&lang=ts"
export * from "./valueSwitch.vue?vue&type=script&lang=ts"
import style0 from "./valueSwitch.vue?vue&type=style&index=0&id=3b893610&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b893610",
  null
  
)

export default component.exports